export enum SchedulingTypeEnum {
  Invalid,
  Immediately,
  Delayed,
  Specified,
  SpecifiedWithDelay,
  OneOffSend,
  Extract
}
